var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowToTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 1280.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6288 11770 c-172 -21 -372 -107 -511 -220 -40 -32 -786 -773 -1659 -1647 -1716 -1718 -1653 -1651 -1729 -1835 -55 -132 -73 -227 -72 -383 0 -119 4 -155 27 -240 171 -648 919 -938 1482 -573 64 41 221 193 836 807 l758 755 3 -3289 2 -3290 22 -80 c113 -417 441 -702 855 -744 519 -52 984 310 1063 829 13 81 15 556 15 3335 l0 3240 758 -757 c808 -807 820 -818 987 -887 140 -59 215 -74 375 -75 195 -1 330 32 487 120 507 283 652 940 315 1424 -48 70 -3156 3189 -3273 3285 -72 60 -217 144 -291 169 -157 53 -317 73 -450 56z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToTop);
export default __webpack_public_path__ + "static/media/arrow_to_top.7d53f81d646628b817e733b32ac5f6d0.svg";
export { ForwardRef as ReactComponent };